import { render, staticRenderFns } from "./ChartHighcharts.vue?vue&type=template&id=67296842&scoped=true"
import script from "./ChartHighcharts.vue?vue&type=script&lang=js"
export * from "./ChartHighcharts.vue?vue&type=script&lang=js"
import style0 from "./ChartHighcharts.vue?vue&type=style&index=0&id=67296842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67296842",
  null
  
)

export default component.exports